export default __webpack_public_path__ + "static/media/close.7d2391b1.svg";